import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';
import AuthShell from '../../components/AuthShell';
import { recuperarContaConfirmarApi } from '../../api';

const STATUS_MSG = {
    invalido: 'Link inválido. Solicite a recuperação novamente.',
    usado: 'Este link já foi usado. Sua conta pode já estar ativa — tente entrar.',
    expirado: 'Este link expirou. Solicite a recuperação novamente.',
    email_em_uso: 'O email escolhido já está em uso por outra conta.',
    erro: 'Não foi possível ativar a conta. Tente novamente.',
};

export default function ConfirmarRecuperarConta() {
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const [estado, setEstado] = useState('processando'); // processando|sucesso|erro
    const [codigo, setCodigo] = useState('erro');

    useEffect(() => {
        let vivo = true;
        if (!token) { setEstado('erro'); setCodigo('invalido'); return; }
        recuperarContaConfirmarApi({ token })
            .then(() => { if (vivo) setEstado('sucesso'); })
            .catch((err) => {
                if (!vivo) return;
                setCodigo(err?.response?.data?.error || 'erro');
                setEstado('erro');
            });
        return () => { vivo = false; };
    }, [token]);

    if (estado === 'processando') {
        return <AuthShell><div className="ueb-auth-card pcenter"><span className="pspin" style={{ color: 'var(--p-accent)' }} /><p className="ueb-auth-sub" style={{ marginTop: 14 }}>Ativando sua conta…</p></div></AuthShell>;
    }

    if (estado === 'sucesso') {
        return (
            <AuthShell>
                <div className="ueb-auth-card pcenter">
                    <div className="ueb-auth-ico is-success"><CheckCircle2 size={40} /></div>
                    <h1>Conta ativada!</h1>
                    <p className="ueb-auth-sub">Seu email e senha foram vinculados. Agora é só entrar.</p>
                    <Link className="pbtn pbtn--primary pbtn--block" to="/login">Ir para o login</Link>
                </div>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <div className="ueb-auth-card pcenter">
                <div className="ueb-auth-ico is-danger"><XCircle size={40} /></div>
                <h1>Não foi possível ativar</h1>
                <p className="ueb-auth-sub">{STATUS_MSG[codigo] || STATUS_MSG.erro}</p>
                <Link className="pbtn pbtn--primary pbtn--block" to="/recuperar-conta">Tentar novamente</Link>
                <p className="ueb-auth-foot"><Link className="plink" to="/login">Voltar ao login</Link></p>
            </div>
        </AuthShell>
    );
}
